import React from 'react'
import CommunityCard from 'components/CommunityCard'
import useCurrentUserEntity from 'hooks/useCurrentUserEntity'
import { Grid, Typography, Box } from '@material-ui/core'
import numberSuffix from 'utils/numberSuffix'
import WelcomeImage from 'img/welcome-word.png'

export default function Welcome({ completeStep, Footer }) {
  const { name, logoUrl: imageUrl, description, donationTotal, memberCount } = useCurrentUserEntity('community', 'communities')

  return (
    <React.Fragment>
      <Grid container alignItems='center'>
        <Grid item xs={12} sm={6} md={8}>
          <CommunityCard { ...{ name, imageUrl, description, donationTotal, memberCount, narrowView: true } } />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Box textAlign='center' p={2}>
            <Box pb={2} width={'100%'} component='img' src={WelcomeImage} />
            <Typography paragraph variant='subtitle2'>
              You're the <strong>{numberSuffix(memberCount)}</strong> member to join our Sixpence community. Welcome to the journey with us.
            </Typography>

            <Typography paragraph variant='body2'>
              In a few simple steps you'll set your tithes and/or roundup donations and then you'll be all set!
            </Typography>
            <Typography paragraph variant='body2'>
              Thanks for helping to make giving a meaningful and natural part of Christian life and community here at {name}!
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <Footer handleClickNext={() => completeStep('Welcome')} />
    </React.Fragment>
  )
}
